import { shallowEqual, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

export const useCloseEditAfterLoad = () => {
  const [isEditOpen, setIsEditOpen] = useState(false);

  const { isUpdating, updateError, isUpdatingApprovalStatus, updateApprovalStatusError } = useSelector(
    (state: MainState) => ({
      isUpdating: state.jobs.isUpdating,
      updateError: state.jobs.updateError,
      isUpdatingApprovalStatus: state.jobs.isUpdatingApprovalStatus,
      updateApprovalStatusError: state.jobs.updateApprovalStatusError
    }),
    shallowEqual
  );

  useEffect(() => {
    if ((!isUpdating && !updateError)) {
      setIsEditOpen(false);
    }
  }, [isUpdating, updateError]);

  useEffect(() => {
    if ((!isUpdatingApprovalStatus && !updateApprovalStatusError)) {
      setIsEditOpen(false);
    }
  }, [isUpdatingApprovalStatus, updateApprovalStatusError]);

  return { isEditOpen, setIsEditOpen }
}